import { motion } from "framer-motion";

const InputField = ({
  input,
  setInput,
  handleSend,
  emailRequest,
  isInputDisabled,
  currentOption,
}) => {
  return (
    <div className="p-4 flex items-center justify-between border-t bg-white">
      <input
        type={emailRequest ? "email" : "text"}
        placeholder={emailRequest ? "Enter your email" : "Type a message"}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className={`border rounded-lg p-2 w-full focus:outline-none ${
          isInputDisabled ? "bg-gray-200" : "bg-white"
        }`}
        disabled={isInputDisabled}
        style={{
          color: isInputDisabled ? "gray" : "black",
        }}
      />
      <motion.button
        className={`ml-3 p-2 ${
          input ? "bg-green-500" : "bg-gray-300"
        } text-white rounded-full`}
        onClick={handleSend}
        whileHover={{ scale: input ? 1.1 : 1 }}
        whileTap={{ scale: input ? 0.9 : 1 }}
        disabled={!input} // Disable button if no input is given
      >
        Send
      </motion.button>
    </div>
  );
};

export default InputField;
